import { Component, OnInit, Input } from '@angular/core';
import { UserService, MessagesServices } from '../../api/';
import { ToastyService, ToastOptions } from 'ng2-toasty';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'follow',
  templateUrl: './follow.component.html',
  styleUrls: ['./follow.component.css']
})
export class FollowComponent implements OnInit {
  @Input() item: any;
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
  msg2: any = '';
  title2: any = '';
  msg3: any = '';
  title3: any = '';
  msg4: any = '';
  title4: any = '';
  @BlockUI() blockUI: NgBlockUI;
  public onlineOffline1: boolean = navigator.onLine;

  constructor(private userService: UserService, private sm: MessagesServices, private toastyService: ToastyService) {
    window.addEventListener('online', () => {this.onlineOffline1 = true; });
    window.addEventListener('offline', () => {this.onlineOffline1 = false});
    this.messages = this.sm.messags;
    this.setMessages();
  }

  ngOnInit() {
  }

  /**
   * setting system messages
   **/
  setMessages() {
    this.msg1 = '';
    this.title1 = '';
    this.msg2 = '';
    this.title2 = '';
    this.msg3 = '';
    this.title3 = '';
    if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_STARTED_FOLLOWING_THIS_USER') {
          this.title1 = this.messages[i].title;
          this.msg1 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_NOT_FOLLOWING_THIS_USER') {
          this.title2 = this.messages[i].title;
          this.msg2 = this.messages[i].message;
        }
        if (this.messages[i].event == 'WG_EVENT_COULDNOT_NOT_FOLLOW') {
          this.title3 = this.messages[i].title;
          this.msg3 = this.messages[i].message;
        }
      }
    }
  }

  public toggleFollow(event) {
    event.stopPropagation();
    event.preventDefault();
    let toastOptions: ToastOptions = {
      title: this.title1,
      msg: this.msg1,
      showClose: true,
      timeout: 2000,
      theme: 'default'
    };
    this.blockUI.start('Loading, please wait...');
    if(this.onlineOffline1) {
      if (this.item._type === 'account') {
        this.userService.toggleFollowAccount(this.item.id).subscribe((res) => {
          toastOptions.msg = (res.is_following === 1) ? toastOptions.msg = this.msg1 : toastOptions.msg = this.msg2;
          this.item.followedByMe = (res.is_following === 1) ? '1' : '0';
          this.blockUI.stop();
          this.toastyService.success(toastOptions);
        }, (err) => {
          toastOptions.msg = this.msg3;
          toastOptions.title = this.title3;
          this.blockUI.stop();
          this.toastyService.error(toastOptions);
        });
      } else if (this.item._type === 'artist') {
        this.userService.toggleFollowArtist(this.item.id).subscribe((res) => {
          this.item.followedByMe = (res.is_following == 1) ? '1' : '0';
          toastOptions.msg = (res.is_following === 1) ? toastOptions.msg = this.msg1 : toastOptions.msg = this.msg2;;
          this.blockUI.stop();
          this.toastyService.success(toastOptions);
        }, (err) => {
          toastOptions.msg = this.msg3;
          toastOptions.title = this.title3;
          this.blockUI.stop();
          this.toastyService.error(toastOptions);
        });
      }
    } else{
      this.blockUI.stop();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/my-discoveries/follow/follow.component.ts